import template from './employee_view_performance_management.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils.js';
import * as PerfManage from '../../lib/performance_management_functions.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewPerformanceManagementViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_id = ko.observable();
		this.employee_info = ko.observable({ name: '', code: '', managers: '' });
		this.logged_in_employee = ko.observable();
		this.employee_managers = ko.observable();
		this.objective_plans = ko.observableArray();
		this.objectives = ko.observableArray();
		this.selected_plan = ko.observable();
		this.batch_file = ko.observable();
		this.has_attachment = ko.observable(false);
		this.showing_feedback = ko.observable(localStorage.getItem('showing_objective_feedback') || false);
		this.measures = ko.observableArray();
		this.rules_progress = ko.observable();
		this.comp_obj_to_add = ko.observableArray();
		this.employee_note = ko.observable();
		this.manager_note = ko.observable();
		this.manager_id = ko.observable();
		this.rating_system_options = ko.observableArray();
		this.rating_system_type = ko.observable();
		this.employee_rating = ko.observable();
		this.employee_ratings = ko.observableArray();
		this.manager_ratings = ko.observableArray();
		this.manager_rating = ko.observable();
		this.current_step = ko.observable();
		this.current_step_sequence = ko.observable();
		this.performance_cycles = ko.observableArray(); 
		this.selected_performance_cycle = ko.observable(null); 
		this.rules = ko.observable({
			all_fields_everyone: true,
			all_fields_employee: true,
			name_description: true,
			outcomes_measures: true,
			feedback_manager: true,
			feedback_employee: true,
			peer_feedback: true,
			setup_peer_reviewer: true,
			add_objectives: true,
			linked_company_objectives: false
		});

		this.is_logged_in = ko.computed(() => {
		this.updateData();
			return this.logged_in_employee() === this.employee_id();
		}, this);

		this.is_manager = ko.computed(() => {
			return this.logged_in_employee() === this.manager_id();
		}, this);

		this.selected_plan.subscribe((val) => {
			this.employee_note('');
			this.employee_rating('');
			this.employee_ratings([]);
			this.manager_ratings([]);
			this.manager_note('');
			this.manager_rating('');
			this.get_obj_details(val);
			this.get_current_step_rules();
			this.get_overall_feedack(val);

			setTimeout(() => {
				this.position_mark_as_done_button();
			}, 300)
		});

		this.selected_performance_cycle.subscribe((val) => { 
			this.updateData();
		});

		// TODO: Do this without jQuery and bootstrap classes in the html (for example without form control and so on)
		$('input[id=batch_file]').change((event) => {
			let file = event.target.files[0]
			if (file)
			{
				$('#upload_input').val(file.name);
				this.has_attachment(true);
			}
			else
			{
				$('#upload_input').val('');
				this.has_attachment(false);
			}
		});

		this.sorted_objectives = ko.computed(() => {
			return this.objectives().sort((a, b) => a.sequence - b.sequence);
		});

		this.showing_feedback.subscribe((val) => {
			localStorage.setItem('showing_objective_feedback', val);
		});

		this.get_employee_info();
	};
	
	position_mark_as_done_button()
	{
		// Ensure this runs after Knockout has updated the DOM
		setTimeout(async () => {
			if (!this.selected_plan() || this.selected_plan().current_step === null)
			{
				// Remove button if it exists 
				let existing_button = document.querySelector('.mark-as-done-btn');
				if (existing_button && existing_button.parentNode) {
					existing_button.parentNode.removeChild(existing_button);
				}
				return; 
			}

			let has_objectives_access = await Permissions.checkAccessRights('PerformanceManagementObjectives');
			let has_admin_access = await Permissions.checkAccessRights('PerformanceManagementAdmin');

   	 		// If user doesn't have either required permission, hide the button and exit
			if (!has_objectives_access && !has_admin_access)
			{
				let existing_button = document.querySelector('.mark-as-done-btn');
				if (existing_button && existing_button.parentNode) 
					existing_button.parentNode.removeChild(existing_button);

				return;
			}
		
			// Find the active step in the progress bar
			let active_step = document.querySelector('.progressbar li.active');
			let done_button = document.querySelector('.mark-as-done-btn');
		
			// If the button doesn't exist, create it
			if (!done_button)
			{
				done_button = document.createElement('button');
				done_button.className = 'ps-btn-primary ps-btn mark-as-done-btn';
				done_button.setAttribute('title', 'Mark current step as done, move to next step');
				done_button.setAttribute('data-visible-feature', 'PerformanceManagementObjectives PerformanceManagementAdmin');
				done_button.innerHTML = '<span class="fa fa-check"></span>&nbsp;<span data-tr="auto" data-tr-section="general">Mark as done</span>';
			
				// Manually add the click handler since Knockout binding won't work on dynamically created element
				done_button.addEventListener('click', () => {
					this.btn_mark_stage_done();
				});
			}
			else
			{
				// Remove button from its current position
				if (done_button.parentNode) 
					done_button.parentNode.removeChild(done_button);
				
			}
		
			if (active_step)
			{
				// Insert button after the active step
				active_step.appendChild(done_button);
			
				done_button.style.cssText = 'display: block !important; visibility: visible !important; margin: 10px 0 !important;';
			}
			else
			{
				let progressbar = document.querySelector('.progressbar');
				if (progressbar && progressbar.parentNode)
				{
					progressbar.parentNode.appendChild(done_button);
					done_button.style.cssText = 'display: block !important; visibility: visible !important; margin: 10px 0 !important;';
				}
			}
		}, 300); // Longer delay
	}
	async get_current_step_rules()
	{
		if (this.selected_plan())
		{
			let rules = await PerfManage.get_current_step_rules(this.selected_plan().performance_cycle_id, this.selected_plan().current_step, this.selected_plan().employee_id);
			let progress = await PerfManage.get_steps_progress(this.selected_plan().performance_cycle_id, this.selected_plan().current_step, this.selected_plan().status);
			this.rules_progress(progress);
			this.rules(rules);
			
			// Wait for DOM to update with the new progress data
			setTimeout(() => {
				this.position_mark_as_done_button();
			}, 300);
		}
	}

	async btn_mark_stage_done()
	{
		let response = await Grape.alerts.confirm({ type: 'info', message: `Mark "${this.selected_plan().current_step_name}" as done?` });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', {
				objective_plan_id: this.selected_plan().objective_plan_id,
				current_step: this.selected_plan().current_step + 1
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Stage/step successfully updated' });

				// Fetch the updated plan data to reflect the new step
				try
				{
					let updated_plan_res = await Grape.fetches.getJSON('/api/record', {
						table: 'v_objective_plans',
						schema: 'perfm_manage',
						filter: [{
							field: 'objective_plan_id',
							operand: '=',
							value: this.selected_plan().objective_plan_id
						}]
					});

					if (updated_plan_res.status !== 'ERROR' && updated_plan_res.records.length > 0)
					{
						// Update the plan in the objective_plans array
						let updated_plan = updated_plan_res.records[0];
						let plan_index = this.objective_plans().findIndex(p =>
							p.objective_plan_id === this.selected_plan().objective_plan_id
						);

						if (plan_index !== -1)
						{
							this.objective_plans.replace(this.objective_plans()[plan_index], updated_plan);
							this.selected_plan(updated_plan);
							await this.get_current_step_rules();
							await this.get_obj_details(updated_plan);
							await this.get_overall_feedack(updated_plan);
							
							setTimeout(() => {
								this.position_mark_as_done_button();
							}, 300);
						}
					}
				}
				catch (error)
				{
					console.error('Error refreshing plan data:', error);
					Grape.alerts.alert({ type: 'error', title: 'Error', message: "Error refreshing plan data" });
					await this.updateData();
					await this.get_current_step_rules();
					
					setTimeout(() => {
						this.position_mark_as_done_button();
					}, 300);
				}
			}
			else
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred while updating current stage/step' });
		}
	}

	async get_employee_info()
	{
		if (this.bindings.employee && ko.isObservable(this.bindings.employee))
		{
			this.bindings.employee.subscribe(async (nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					//this.logged_in_employee(parseInt(localStorage.getItem('employee_id')));
					this.updateData();
				}
			});
		}

		if (this.bindings.employee_id && ko.isObservable(this.bindings.employee_id))
			this.bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });
	};

	async btn_delete_plan(data)
	{
		let response = await Grape.alerts.confirm({
			type: 'warning', 
			message: `Are you sure you want to delete ${data.name}?`
		});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/remove', {
				objective_plan_id: data.objective_plan_id
			});
		
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: 'Successfully deleted'});
		        // Remove the plan from the observable array
				this.objective_plans.remove(data);
		        // Clear selected plan if it was the deleted one
				this.selected_plan(null);
			}
			else
				Grape.alerts.alert({type: 'error', message: 'An error occurred while deleting the Objective Plan'});
		}

	}
	async btn_save_overall_note()
	{
		let note;
		let rating;
		if (this.is_manager())
		{
			note = this.manager_note();
			if (this.rating_system_type() === 'multiselect')
				rating = this.manager_ratings().toString();
			else
				rating = this.manager_rating().toString();
		}
		else
		{
			note = this.employee_note();
			if (this.rating_system_type() === 'multiselect')
				rating = this.employee_ratings().toString();
			else
				rating = this.employee_rating().toString();
		}

		let response = await Grape.alerts.confirm({ type: 'info', message: 'Update overall feedback?'});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan_feedback/edit', {
				objective_plan_id: this.selected_plan().objective_plan_id,
				employee_id: this.logged_in_employee(),
				notes: note,
				rating: rating
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.updateData();
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updating feedback.')});
		}
	}

	async btn_add_objetive_plan(data)
	{
		await Grape.dialog.open('AddObjectivePlan', { employee_info: this.employee(), edit: false});
		this.updateData();
	}

	async btn_edit_objective_plan(data) {
		let res = await Grape.dialog.open('AddObjectivePlan', { 
			employee_info: this.employee(), 
			data: data, 
			edit: true 
		});
		
		// After editing, fetch the updated plan data
		try
		{
			let updated_plan_res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objective_plans',
				schema: 'perfm_manage',
				filter: [{
					field: 'objective_plan_id',
					operand: '=',
					value: data.objective_plan_id
				}]
			});
	
			if (updated_plan_res.status !== 'ERROR' && updated_plan_res.records.length > 0) {
				// Update the plan in the objective_plans array
				let updated_plan = updated_plan_res.records[0];
				let plan_index = this.objective_plans().findIndex(p => 
					p.objective_plan_id === data.objective_plan_id
				);
				
				if (plan_index !== -1)
				{
					// Update in the array
					this.objective_plans.replace(this.objective_plans()[plan_index], updated_plan);
					
					// If this was the selected plan, update the selected plan
					if (this.selected_plan() && this.selected_plan().objective_plan_id === data.objective_plan_id) 
						this.selected_plan(updated_plan);
				}
			}
		}
		catch (error)
		{
			console.error('Error refreshing plan data:', error);
			Grape.alerts.alert({
				type: 'error', message: window.tr('Error refreshing plan data')
			});
		}
		
		this.updateData();
	}

	async btn_edit_an_objective(data)
	{
		if (data.editing())
		{
			let response = await Grape.alerts.confirm({type: 'info', title: 'Confirm', message: 'Are you sure want to save changes to this objective?'});
			if (response)
			{
				try {
					let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
						objective_id: data.objective_id,
						name: data.name,
						description: data.description,
						expected_result: data.expected_result,
						measure: data.measure
					});
					if (res.status == 'ERROR')
						Grape.alerts.apiError(res);
					else if (res.status == 'OK')
						this.get_obj_details(data.objective_plan_id);
					else
						Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while attempting to save changes to this objective. We apologise for the inconvenience...')});
				} catch (error) {
					console.error(error);
					Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while attempting to save changes to this objective. We apologise for the inconvenience...')});
				}
			}
		}
		else
			data.editing(!data.editing());
	}

	async btn_edit_emp_feedback(data)
	{
		if (data.editing_emp_feedback())
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
				objective_id: data.objective_id,
				employee_id: data.employee_id,
				feedback: data.employee_feedback
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.get_obj_details(this.selected_plan());
				data.editing_emp_feedback(!data.editing_emp_feedback());
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updating feedback.')});
		}
		else
			data.editing_emp_feedback(!data.editing_emp_feedback());
	}

	async btn_edit_manager_feedback(data)
	{
		if (data.editing_manager_feedback())
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
				objective_id: data.objective_id,
				employee_id: Utils.current_employee_id(),
				feedback: data.manager_feedback
			});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: window.tr('Successfully updated your feedback.')});
				this.get_obj_details(this.selected_plan());
				data.editing_manager_feedback(!data.editing_manager_feedback());
			}
			else
				Grape.alerts.alert({type: 'error', message: window.tr('An error occurred while updated feedback.')});
		}
		else
			data.editing_manager_feedback(!data.editing_manager_feedback());
	}

	async btn_cancel_delete_feedback(data)
	{
		if (data.editing_emp_feedback())
			data.editing_emp_feedback(!data.editing_emp_feedback());
		else if (data.editing_manager_feedback())
			data.editing_manager_feedback(!data.editing_manager_feedback());
		else if (!data.editing_emp_feedback() && !data.editing_manager_feedback())
		{
			let response = await Grape.alerts.confirm({ type: 'warning', messsage: window.tr('Are you sure you want to remove this feedback?')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/remove', { 
					objective_feedback_id: data.objective_feedback_id,
					employee_id: Utils.current_employee_id(),
					feedback: ''
				});
				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
				{
					Grape.alerts.alert({type: 'Success', message: tr('Successfully removed feedback')});
					this.get_obj_details(data.objective_plan_id);
				}
			}
		}
	}

	async btn_cancel_remove_objective(data)
	{
		if (data.editing())
			data.editing(!data.editing);
		else
		{
			let response = await Grape.alerts.confirm({ type: 'warning', message: tr('Are you sure you want to remove this objective?')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/performance_management/objective/remove_from_plan', { objective_id: data.objective_id });
				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
				{
					Grape.alerts.alert({type: 'Success', message: tr('Successfully removed objective')});
					this.get_obj_details(data.objective_plan_id);
				}
			}
		}
	}

	async move_order_up(data)
	{
		let sequence;
		if (data.sequence > 1)
			sequence = parseInt(data.sequence) - 1;
		else
			sequence = data.sequence;
		try {
			let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
				objective_id: data.objective_id,
				sequence: sequence
			});
			if (res.status != 'ERROR')
				this.get_obj_details(data);
		} catch (error) {
			console.error(error);
		}
	}

	async move_order_down(data)
	{
		let sequence = parseInt(data.sequence) + 1;
		try {
			let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
				objective_id: data.objective_id,
				sequence: sequence
			});
			if (res.status != 'ERROR')
				this.get_obj_details(data);
		} catch (error) {
			console.error(error);
		}
	}

	show_help()
	{
		Grape.dialog.open('PerformanceObjectivesSummaryHelp', {});
	};

	show_details_help()
	{
		Grape.dialog.open('PerformanceObjectiveDetailsHelp', {});
	};

	async btn_add_objective_to_plan()
	{
		await Grape.dialog.open('AddToObjectivePlan', { employee_info: this.employee(), data: this.selected_plan()});
		this.get_obj_details(this.selected_plan());
	}

	select_objective_plan_click(data)
	{
		this.selected_plan(data);
		this.rating_system_type(data.rating_method_type);
		// Reposition button when a new plan is selected
		setTimeout(() => {
			this.position_mark_as_done_button();
		}, 300);
	}

	async updateData()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'measure',
				schema: 'perfm_manage'
			})

			if (res.status != 'ERROR')
				this.measures(res.records);
		} catch (error) {
			console.error(error);
		}

		try {
			if (this.employee())
			{
				let data_query = {
					table: 'v_objective_plans',
					schema: 'perfm_manage',
					filter: [{
						field: 'employee_id',
						operand: '=',
						value: this.employee_id()
					}]
				}

				if (this.selected_performance_cycle())
					data_query.filter.push({ field: 'cycle_name', operand: '=', value: this.selected_performance_cycle() }); 
				
				let res = await Grape.fetches.getJSON('/api/record', data_query);

				if (res.status != 'ERROR') 
				{
					this.objective_plans(res.records);
					if (!this.selected_performance_cycle()) {
						let uniqueCycleNames = [...new Set(res.records.map(record => record.cycle_name))];

						this.performance_cycles(uniqueCycleNames);
					}
				}				
			}
		}
		catch (error)
		{
			console.error(error);
		}

		try {
			if (this.employee())
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_employee_profile',
					schema: 'savanna',
					filter: [{
						field: 'employee_id',
						operand: '=',
						value: this.employee_id()
					}]
				});
	
				if (res.status != 'ERROR')
				{
					if (res.records[0].employee_managers)
					{
						this.employee_info({
							name: this.employee().firstname + ' ' + this.employee().surname || '',
							code: this.employee().employment_info[0].employee_code || ' ',
							managers: res.records[0].employee_managers[0].fullnames || ' ',
							manager_ids: res.records[0].employee_managers[0].employee_id
						});
					}
					else
						this.employee_info({
							name: this.employee().firstname + ' ' + this.employee().surname || '',
							code: this.employee().employment_info[0].employee_code || ' ',
							managers: 'none',
							manager_ids: null
						});
				}
			}
		} catch (error) {
			console.error(error);
		}

		this.employee_managers(this.employee_info().managers);
		this.manager_id(this.employee_info().manager_ids);
		this.get_obj_details(this.selected_plan());
		this.get_current_step_rules();
		this.get_overall_feedack(this.selected_plan());

		setTimeout(() => {
			this.position_mark_as_done_button();
		}, 300);
	};

	async get_overall_feedack(data)
	{
		//get rating system options:
		try {
			if (this.selected_plan())
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'rating_system_option',
					schema: 'perfm_manage',
					filter: [{
						field: 'rating_system_id',
						operand: '=',
						value: this.selected_plan().rating_system_id
					}]
				});
				if (res.status != 'ERROR')
					this.rating_system_options(res.records);
			}
			else
				return;

		} catch (error) {
			console.error(error);
		}

		try {
			if (this.selected_plan())
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'emp_manager_rating',
					schema: 'perfm_manage',
					filter: [{
						field: 'objective_plan_id',
						operand: '=',
						value: this.selected_plan().objective_plan_id
					}]
				});
				if (res.status != 'ERROR')
				{
					res.records.forEach(record => {
						if (record.employee_id === this.employee_id())
						{
							this.employee_note(record.notes || '');
							if (this.rating_system_type() === 'multiselect')
							{
								let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
								this.employee_ratings(rating_array);
							}
							else if (this.rating_system_type() === 'single-select')
							{
								let rating = parseInt(record.rating);
								this.employee_rating(rating);
							}
							else
								this.employee_rating(record.rating);
						}
						else if (record.employee_id === this.manager_id())
						{
							this.manager_note(record.notes || '');
							if (this.rating_system_type() === 'multiselect')
							{
								let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
								this.manager_ratings(rating_array);
							}
							else if (this.rating_system_type() === 'single-select')
							{
								let rating = parseInt(record.rating);
								this.manager_rating(rating);
							}
							else
								this.manager_rating(record.rating);
						}
					});
				}
			}
			else
				return;

		} catch (error) {
			console.error(error);
		}
		Utils.refresh_data_visible_roles();
	}

	async get_obj_details(data)
	{
		if (data)
		{
			let objective_plan_id = parseInt(data.objective_plan_id) || this.selected_plan().objective_plan_id;
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objectives_for_objective_plan',
				schema: 'perfm_manage',
				sort_order: 'ASC',
				sort_field: 'sequence',
				filter: [{
					field: 'objective_plan_id',
					operand: '=',
					value: objective_plan_id
				}]
			});
			if (res.status != 'ERROR')
			{
				let items = res.records.map((x) => ({
					...x,
					editing: ko.observable(false),
					editing_emp_feedback : ko.observable(false),
					editing_manager_feedback : ko.observable(false),
					linked_company_objectives: ko.observable((x.linked_company_objectives || []).map((x) => ({
						...x,
						display_name: x.number + ' ' + x.description
					 // Add a description to use as title when hovering that will show if it is a subgoal, goal, or entire objective and to who it belongs
					})))
				}));
				this.objectives(items);
			}
		}
		Utils.refresh_data_visible_roles();
	}




	async btn_view_plan(data)
	{
		let progress = await PerfManage.get_steps_progress(data.performance_cycle_id, data.current_step, data.status);
		Grape.dialog.open('ViewPerfObjectivePlan', {data: data, employee_info: this.employee_info(), progress: progress, manager_id: this.manager_id(), employee_id: this.employee_id() });
	}

	async btn_edit_linked_comp_objectives(data)
	{
		let res = await Grape.dialog.open('LinkCompanyObjectives', { data: data, to_add: null, to_remove: null, editing: true, linked_comp_objectives: data.linked_company_objectives() || []});
		this.get_obj_details(this.selected_plan());
	}
}

export default {
	name: 'employee_view_performance_management',
	viewModel: EmployeeViewPerformanceManagementViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_performance_management'
};
